import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { StandardChip } from "../../../../../shared/components/badges/StandardChip"
import { LocalizedEnum } from "../../../../localization/components/AppLocalized"

import { MeetingRoomBookingState } from "../meetingRoomsTypes"
import { BOOKING_STATE_CHIP_VARIANTS, LIVE_DOT } from "./helpers"

const useStyles = makeStyles()(() => ({
    liveDot: LIVE_DOT,
}))

type MeetingRoomBookingStateChipProps = Readonly<{
    state: MeetingRoomBookingState
}>

export function MeetingRoomBookingStateChip({ state }: MeetingRoomBookingStateChipProps) {
    const { classes } = useStyles()

    return (
        <StandardChip placement="table" size="small" variant={BOOKING_STATE_CHIP_VARIANTS[state]}>
            <Stack direction="row" alignItems="center" spacing=".375rem" component="span">
                {state === MeetingRoomBookingState.IN_PROGRESS && <span className={classes.liveDot} />}
                <LocalizedEnum base="service-center-meeting-rooms-booking-state" enumValue={state}>
                    <span>{state}</span>
                </LocalizedEnum>
            </Stack>
        </StandardChip>
    )
}
